import { SwapOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';

import useAPIQuery from '../../api/useAPIQuery';
import { CandidateDetail, JobPostingDetail } from '../../types';
import styles from './ApplicantHistory.module.css';

interface ApplicantHiredTimelineProps {
  recruiterName: string;
  createdDate: string;
  candidateId: CandidateDetail['id'];
  opportunityTitle?: string;
  opportunityId?: JobPostingDetail['id'];
}

const ApplicantHiredTimeline = ({
  recruiterName,
  createdDate,
  candidateId,
  opportunityTitle,
  opportunityId,
}: ApplicantHiredTimelineProps) => {
  const recruitmentProcess = useAPIQuery(
    [
      '/recruitment-processes/',
      {
        params: {
          candidate: candidateId,
          job_posting: opportunityId,
        },
      },
    ],
    {
      enabled: !!opportunityId,
      select(data) {
        return data.count > 0 ? data.results[0] : null;
      },
    }
  );

  return (
    <Timeline.Item dot={<SwapOutlined className={styles.sucessColor} />}>
      <Card>
        <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
        <br />
        <Typography.Text strong>{recruiterName} aprovou</Typography.Text> o(a) candidato(a) na vaga{' '}
        <Typography.Text strong>{opportunityTitle}</Typography.Text> com a data de admissão{' '}
        <Typography.Text strong>
          {moment(recruitmentProcess.data?.admission_date).format('L')}
        </Typography.Text>
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantHiredTimeline;
